module.exports = __webpack_public_path__ + "img/Logotipo_Dos tintas.1c146a48.png";